import ProductsAndDocumentsWithCarousel from './ProductsAndDocumentsWithCarousel';
import React, { useState, useEffect } from 'react';
import DtmTags from '../../../../common/dtmTags';
import ProductsAndDocumentsWithoutCarousel from './ProductsAndDocumentsWithoutCarousel';
import PropTypes from 'prop-types';
import Classes from '../../../../common/Classes';
import ExhibitorModal from './ExhibitorModal';
import StringFormatter from '../../../../common/StringFormatter';
import { Packages, ItemType, MaxProducts, MaxDocuments } from '../../../../common/Constants';
import Carousel from './Carousel';
import {trackMixpanelEvent} from '../../../../common/MixpanelHelper';
import mixpanelConstants from '../../../../common/mixpanelConstants';
import Utils from '../../../../common/Utils';

const ExhibitorInfoSection = (props) => {
    const { exhibitor,translations,isPrioritySlotPremiumExhibitor, navigation } = props;
    const maxProducts = exhibitor.packageId === Packages.gold ? MaxProducts.Gold : MaxProducts.Silver;
    const maxDocuments = exhibitor.packageId === Packages.gold ? MaxDocuments.Gold : MaxDocuments.Silver;

    const totalProducts = exhibitor.products ? exhibitor.products : [];
    const products = totalProducts.filter((product)=> (product.imageUrl && product.imageUrl.trim() !== '') &&
            (product.name && product.name.trim() !== '')).slice(0, maxProducts);
    const overlayProducts = totalProducts.filter((product)=> (product.imageUrl && product.imageUrl.trim() !== '') &&
        (product.name && product.name.trim() !== '')).slice(0, MaxProducts.OverLay);

    const totalDocuments = exhibitor.documents ? exhibitor.documents : [];
    const documents = totalDocuments.filter((document)=> (document.url && document.url.trim() !== '') &&
    (document.title && document.title.trim() !== '')).slice(0, maxDocuments);
    const overlayDocuments = totalDocuments.filter((document)=> (document.url && document.url.trim() !== '') &&
        (document.title && document.title.trim() !== '')).slice(0, MaxDocuments.OverLay);

    const displayCarousel = (totalDocuments.length !== 0 && totalProducts.length >= 3) || (totalProducts.length !== 0 && totalDocuments.length >= 3);
    const isProductOrDocumentEmpty = totalProducts.length === 0 || totalDocuments.length === 0;
    const productsTitle = StringFormatter.format(translations.exhibitorInfoSection.productsTitle, totalProducts.length)
    const documentsTitle = StringFormatter.format(translations.exhibitorInfoSection.documentsTitle, totalDocuments.length);
    const [showModal, setShowModal] = useState(false);
    let [modalType, setModalType] = useState('');

    const [clickedSlideIndex, setClickedSlideIndex] = useState(0);

    const getDtmTag = (type) => {
        const packageName = exhibitor.packageId === Packages.gold ? 'gold' : 'silver';
        const dtm = DtmTags.exhibitorDirectory[packageName];
        return isPrioritySlotPremiumExhibitor ? `${dtm[type]}${dtm.prioritySlot}` : dtm[type];
    }

    const getMixpanelProps = () => {
        return {
            exhibitorId: exhibitor.id,
            exhibitorName: exhibitor.name,
            packageName: Utils.getPackageName(exhibitor.packageId),
            component: mixpanelConstants.component.exhibitorDirectory,
            subComponent: isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
        }
    }

    const openModal = (index, type) => {
        console.log('type', type);
        setClickedSlideIndex(index);
        setShowModal(true);
        setModalType(type);
        let props = getMixpanelProps();
        if(type === ItemType.Document){
            props = {
                ...props,
                documentName: Utils.removePdfFileNameExtension(exhibitor.documents[index].title),
                documentType: exhibitor.documents[index].type.toLowerCase(),
                type: mixpanelConstants.type.exhibitor
            }
            trackMixpanelEvent(mixpanelConstants.eventName.documentClicked, props);
        }
        if(type === ItemType.Product){
            props = {
                ...props,
                productId: exhibitor.products[index].id,
                productName: exhibitor.products[index].name,
                element: exhibitor.products[index].video?.id ? mixpanelConstants.element.productVideo : mixpanelConstants.element.productImage,
            }
            trackMixpanelEvent(mixpanelConstants.eventName.productClicked, props);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        const root = document.getElementsByTagName( 'html' )[0];
        root.style.overflow = showModal ? 'hidden' : '';
    }, [showModal]);

    const renderModal = () => {
        return showModal ?
            <ExhibitorModal
                showModal={showModal}
                closeModal={closeModal}
                products={overlayProducts}
                documents={overlayDocuments}
                clickedSlideIndex={clickedSlideIndex}
                setClickedSlideIndex={setClickedSlideIndex}
                translations={translations}
                exhibitingOrganisation={exhibitor}
                navigation={navigation}
                type={modalType}
            /> : null
    }

    const renderProductOrDocumentWithSlider = () => {
        return (
                <div className={Classes.goldProductAndDocumentContainer}>
                    {(products.length > 0 &&
                        <div  data-testId="products_with_slider">
                            <h6 className={Classes.productsTitleInDirectory}>{productsTitle}</h6>
                            <Carousel
                                items={products}
                                translations={translations}
                                exhibitorId={exhibitor.id}
                                type={ItemType.Product}
                                onClick={openModal}
                                mixpanelProps={getMixpanelProps()}
                                getDtmTag={getDtmTag}
                            />
                        </div>
                    )}
                    {(documents.length > 0 &&
                        <div  data-testId="documents_with_slider">
                            <h6 className={Classes.documentsTitleInDirectory}>{documentsTitle}</h6>
                            <Carousel
                                items={documents}
                                translations={translations}
                                exhibitorId={exhibitor.id}
                                type={ItemType.Document}
                                onClick={openModal}
                                mixpanelProps={getMixpanelProps()}
                                getDtmTag={getDtmTag}
                            />
                        </div>)}
                </div>
        )
    };

    return <>
        {exhibitor.packageId === Packages.gold && displayCarousel ?
            <div className={Classes.goldProductAndDocumentContainer} data-testId="gold_products_and_documents">
                <ProductsAndDocumentsWithCarousel
                    products={products}
                    documents={documents}
                    exhibitorId={exhibitor.id}
                    productsTitle={productsTitle}
                    documentsTitle={documentsTitle}
                    translations={translations}
                    getDtmTag={getDtmTag}
                    onClick={openModal}
                    mixpanelProps={getMixpanelProps()}
                />
            </div>
          : exhibitor.packageId === Packages.gold && isProductOrDocumentEmpty ? renderProductOrDocumentWithSlider()
          : <div className={Classes.silverProductAndDocumentContainer} data-testId="silver_products_and_documents">
                <ProductsAndDocumentsWithoutCarousel
                    products={products}
                    documents={documents}
                    exhibitorId={exhibitor.id}
                    productsTitle={productsTitle}
                    documentsTitle={documentsTitle}
                    isPrioritySlotPremiumExhibitor={isPrioritySlotPremiumExhibitor}
                    translations={translations}
                    getDtmTag={getDtmTag}
                    onClick={openModal}
                    mixpanelProps={getMixpanelProps()}
                />
            </div>
        }
        {renderModal()}
    </>
}

ExhibitorInfoSection.propTypes = {
    exhibitor : PropTypes.object.isRequired,
    translations : PropTypes.object.isRequired,
    isPrioritySlotPremiumExhibitor : PropTypes.bool.isRequired,
    navigation : PropTypes.object.isRequired,
}

export default ExhibitorInfoSection;
